export const LOAD_ASSESSORS = 'LOAD_ASSESSORS';
export const LOAD_AD_USERS = 'LOAD_AD_USERS';
export const UPDATE_ASSESSOR = 'UPDATE_ASSESSOR';
export const EDIT_ASSESSOR = 'EDIT_ASSESSOR';
export const SAVE_ASSESSOR = 'SAVE_ASSESSOR';
